import React, { useState, useContext, useMemo, useEffect } from 'react'
import { AuthContext } from '../../contexts/AuthContext'
import TurnazioneCalendar from './TurnazioneCalendar'
import SectorSelector from './SectorSelector'
import SectorManager from './SectorManager'
import api from '../../services/api'
import '../../css/turnazione.css'

export default function TurnazionePage() {
  const { user, hasPermission } = useContext(AuthContext)
  const [tab, setTab] = useState('calendar')
  const [selectedSector, setSelectedSector] = useState(null)
  const [viewMode, setViewMode] = useState('month')
  const [refresh, setRefresh] = useState(0)
  const [sectors, setSectors] = useState([])
  const [users, setUsers] = useState([])

  const canManageSectors = useMemo(() => {
    if (!user) return false
    const roles = user.roles || []
    return roles.some(r => r.name === 'admin') || hasPermission('sectors_edit')
  }, [user, hasPermission])

  const canCreateShift = useMemo(() => {
    return hasPermission('shifts_create') || hasPermission('shifts_create_own')
  }, [hasPermission])

  const tabs = useMemo(() => {
    const base = [{ key: 'calendar', label: 'Calendario Turni', icon: 'fas fa-calendar-alt' }]
    if (canManageSectors) {
      base.push({ key: 'sectors', label: 'Gestione Settori', icon: 'fas fa-cogs' })
    }
    return base
  }, [canManageSectors])

  useEffect(() => {
    const loadData = async () => {
      try {
        const [sectorsRes, usersRes] = await Promise.all([
          api.get('/sectors'),
          api.get('/accounts'),
        ])
        setSectors(sectorsRes.data || [])
        setUsers(usersRes.data || [])
      } catch (err) {
        console.error('Failed to load turnazione data:', err)
      }
    }
    loadData()
  }, [refresh])

  const handleSectorChange = (value) => {
    setSelectedSector(value === '' ? null : value)
  }

  const triggerRefresh = () => setRefresh(k => k + 1)

  return (
    <div className="turnazione-wrap">
      <header className="turnazione-header">
        <h1 className="turnazione-title">
          <i className="fas fa-calendar-check" /> Turnazione
        </h1>
      </header>

      <nav className="turnazione-tabs" aria-label="Turnazione tabs">
        <div className="turnazione-tabs__scroller">
          {tabs.map(t => (
            <button
              key={t.key}
              type="button"
              className={`turnazione-tabs__btn ${tab === t.key ? 'is-active' : ''}`}
              onClick={() => setTab(t.key)}
            >
              <i className={t.icon} /> {t.label}
            </button>
          ))}
        </div>
      </nav>

      {tab === 'calendar' && (
        <>
          <div className="turnazione-toolbar">
            <SectorSelector
              sectors={sectors}
              selected={selectedSector}
              onChange={handleSectorChange}
            />
            <div className="view-toggle">
              <button
                type="button"
                className={viewMode === 'month' ? 'is-active' : ''}
                onClick={() => setViewMode('month')}
              >
                <i className="fas fa-th" /> Mese
              </button>
              <button
                type="button"
                className={viewMode === 'week' ? 'is-active' : ''}
                onClick={() => setViewMode('week')}
              >
                <i className="fas fa-list" /> Settimana
              </button>
            </div>
          </div>

          <TurnazioneCalendar
            sectorId={selectedSector}
            viewMode={viewMode}
            refreshKey={refresh}
            onShiftChange={triggerRefresh}
            sectors={sectors}
            users={users}
            canCreate={canCreateShift}
          />
        </>
      )}

      {tab === 'sectors' && canManageSectors && (
        <SectorManager
          sectors={sectors}
          onChanged={triggerRefresh}
        />
      )}
    </div>
  )
}
